<template>
    <div>
        <el-form :model="evalInfo" :rules="rules" ref="evalInfo" class="demo-ruleForm">
            <div class="form-row">
                <div class="form-label">
                    <label class="required">商品满意度</label>
                </div>
                <div class="form-value width-1-5x mt10">
                    <el-form-item prop="score">
                        <el-rate v-model="evalInfo.score"></el-rate>
                    </el-form-item>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>买家印象</label>
                </div>
                <div class="form-value width-1-5x">
                    <ul class="enum-list clearfix">
                        <li :class="checkedselect(item.id) ? 'enum-item checked' : 'enum-item'" v-for="item in tags" @click="select(item)">{{item.name}}<i></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>买家心得</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="comment">
                        <el-input type="textarea" v-model="evalInfo.comment"></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <!-- 上传附件 -->
        <div class="form-info">
            <div class="form-row" style="overflow: hidden;height: auto">
                <div class="form-label">
                    <label>上传图片</label>
                </div>
                <div class="form-value width-3x">
                    <div class="mt5">
                        <swb-file-upload :fileFor="'solution'" fileGroup="file-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                        <div class="file-area clearfix">
                            <div class="mr15 inline-block" v-for="(evalFile, index) in evalFileList">
                                <div class="file-item show-usage image deletable viewable downloadable editable" v-if="evalFile.fileExtName == 'jpg' || evalFile.fileExtName == 'png' || evalFile.fileExtName == 'jpeg'|| evalFile.fileExtName == 'JPEG'">
                                    <div class="file-content">
                                        <div class="usage ellipsis-1">{{evalFile.fileName}}</div>
                                        <img :src="evalFile.fileBrowseUrl"/>
                                        <div class="operation-group">
                                            <i class="icon iconfont icon-chakan view" @click="viewImage(evalFile.fileBrowseUrl)"></i>
                                        </div>
                                        <div class="delete-icon" @click="removeUpload(index)"></div>
                                    </div>
                                </div>
                                <div class="file-item show-usage deletable viewable downloadable editable" v-else>
                                    <div class="file-content">
                                        <div class="usage ellipsis-1">{{evalFile.fileName}}</div>
                                        <img :src="evalFile.fileBrowseUrl"/>
                                        <div class="operation-group">
                                            <i class="icon iconfont icon-xiazai download" @click="downloadFile(evalFile.fileUuid);"></i>
                                        </div>
                                        <div class="delete-icon" @click="removeUpload(index)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import goodsCategApi from '../../api/goodsCateg'

    export default {
        name: 'swb-order-goods-eval-save',
        desc: '商品订单评价',
        props: ["item"],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空'));
                } else {
                    callback();
                }
            };
            return {
                evalInfo: {
                    score: 1
                },
                tags: [],
                tagIds: [],
                evalFileList: [],
                rules: {
                    score: [
                        {validator: checkNull, trigger: 'blur'}
                    ]
                }
            }
        },
        created: function () {
            // 获取标签
            this.getOrderGoodsEvalTags();
        },
        methods: {
            select(tag){
                let self = this;
                let index = self.checkedselect(tag.id);
                if(!index) {
                    self.tagIds.push(tag);
                } else {
                    self.tagIds.remove(tag);
                }
            },
            checkedselect(tagId){
                let self = this;
                for(let i = 0; i < self.tagIds.length; i++) {
                    if(self.tagIds[i].id === tagId) {
                        return true;
                    }
                }
                return false;
            },
            //
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let file = files[i];
                        if(file.fileExtName == 'jpg' || file.fileExtName == 'png' || file.fileExtName == 'JPEG' || file.fileExtName == 'jpeg') {
                            self.evalFileList.push(file);
                        } else {
                            MsgBox.warning('支持 jpg、png、jpeg 图片格式！')
                        }
                    }
                } else {
                    this.$message.success(result.message);
                }
            },
            viewImage: function (fileBrowseUrl) {

                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            removeUpload: function (index) {
                let self = this;
                self.evalFileList.splice(index, 1);
            },
            downloadFile: function (fileUuid) {
                Utils.downloadFile(getAppUrl("/file/download?uuid=" + fileUuid));
            },
            //
            getOrderGoodsEvalTags: function () {
                let self = this;
                let postData = {};
                postData.catId = self.item.catId;     // self.catId
                //
                let msgBoxDlg = MsgBox.loading();
                goodsCategApi.getGoodsCatEvalTagList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.tags = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                self.evalInfo.recvVoucherItemId = self.item.id; // 收货订单项 Id
                self.evalInfo.goodsCatEvalTags = self.tagIds;    // 标签
                self.evalInfo.orderGoodsEvalFileList = self.evalFileList;    // 附件
                this.$refs['evalInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = 'info';
                        result.data = self.evalInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                //console.log("往后台请求的评价数据............");
                //console.log(result);
                return result;
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsEvalSave.vue